import React from 'react';
import { Link, useLocation, useRoutes } from 'react-router-dom';
import adminRouteConfig from '../../adminRouteConfig';
import { Layout, Menu, Result, Button } from 'antd';

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

export default function Navigation() {
    const { pathname } = useLocation();
    
    return (
        <Sider theme="light" width={200} className="site-layout-background">
            <Menu
                selectedKeys={[pathname.split("/")[2]]}
                mode="inline"
                theme="light"
            // inlineCollapsed={this.state.collapsed}
            >
                {Object.values(adminRouteConfig).map(rc => {
                    if (rc.hideInNav) { return undefined; }
                    if (rc.children) {
                        return <SubMenu key={rc.key} icon={<rc.icon />} title={rc.name}>
                            {_buildRouteMenuWithChildren(rc)}
                        </SubMenu>
                    } else {
                        return <Menu.Item key={rc.key} icon={<rc.icon />}>
                            <Link to={rc.path}>{rc.name}</Link>
                        </Menu.Item>
                    }
                })}
            </Menu>
        </Sider>
    )
}

const _buildRouteMenuWithChildren = (routeConfig) => {
    let children: any = undefined;

    if (routeConfig.children) {
        children = <Link to={routeConfig.path}>
            <Menu.ItemGroup key={routeConfig.key} title={routeConfig.name}>
                {routeConfig.children.map(rc => {
                    if (rc.children) {
                        return <SubMenu key={rc.key} icon={<rc.icon />} title={rc.name}>
                            {_buildRouteMenuWithChildren(rc)}
                        </SubMenu>
                    } else {
                        return <Menu.Item key={rc.key} icon={<rc.icon />}>
                            <Link to={rc.path}>{rc.name}</Link>
                        </Menu.Item>
                    }
                })}
            </Menu.ItemGroup>
        </Link>
    }

    return children;
}
